<template>
  <div id="filosofia">
    <div class="section">
      <div
        class="container fadeInUp wow"
        data-wow-duration="0.5s"
      >
        <h3>Filosofía de gestión</h3>
        <div class="line bg-primary"></div>
        <div class="row row-cols-1 row-cols-lg-2 mt-5">
          <div class="col mb-4">
            <div class="card bg-transparent border text-center h-100">
            <div class="card-body">
              <h2 class="pb-3"><font-awesome-icon icon="diagnoses" size="lg" /></h2>
              <h4 class="text-primary">Misión</h4>
              <p>
                Entregar a nuestros clientes una gestión integral en el desarrollo de sus proyectos, disminuyendo variables de incertidumbre en costos, plazos y calidad.
              </p>
            </div>
          </div>
          </div>
          <div class="col mb-4">
            <div class="card bg-transparent border text-center h-100">
            <div class="card-body">
              <h2 class="pb-3"><font-awesome-icon icon="eye" size="lg" /></h2>
              <h4 class="text-primary">Visión</h4>
              <p>
                Clientes satisfechos, mediante el conocimiento de variables que pueden afectar el desarrollo de sus proyectos de construcción.
              </p>
            </div>
          </div>
          </div>
        </div>
      </div>    
    </div>
  </div>
</template>
<script>
export default {
  name: "Filosofia"
};
</script>
